import * as React from 'react';


export default class uploadVideo extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <svg className={this.props.className} xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 50 62">
                <defs>
                    <path id="a" d="M48.941 11.596v45.816a2.824 2.824 0 0 1-2.823 2.823H2.824A2.824 2.824 0 0 1 0 57.412V2.824A2.824 2.824 0 0 1 2.824 0h34.522a3 3 0 0 1 2.12.879l8.596 8.595a3 3 0 0 1 .88 2.122z"/>
                    <path id="b" d="M11.541 7.945l8.136 4.1a2 2 0 0 1 .06 3.54L11.6 20.033a2 2 0 0 1-2.959-1.755V9.731a2 2 0 0 1 2.9-1.786z"/>
                </defs>
                <g fill="none" fillRule="evenodd">
                    <g transform="translate(.53 .882)">
                        <use fill="#FFF" xlinkHref="#a"/>
                        <path stroke="#E4E4E4" strokeWidth="2" d="M47.941 11.596a2 2 0 0 0-.586-1.415L38.76 1.586A2 2 0 0 0 37.346 1H2.824A1.824 1.824 0 0 0 1 2.824v54.588c0 1.007.816 1.823 1.824 1.823h43.294a1.824 1.824 0 0 0 1.823-1.823V11.596z"/>
                    </g>
                    <g transform="translate(11 18)">
                        <circle cx="14" cy="14" r="14" stroke="#FF8A8A" strokeWidth="2"/>
                        <use fill="#FFCECE" xlinkHref="#b"/>
                        <path stroke="#FF8A8A" strokeWidth="2" d="M11.091 8.838a1 1 0 0 0-1.45.893v8.546a1 1 0 0 0 1.48.878l8.136-4.447a1 1 0 0 0-.03-1.77l-8.136-4.1z"/>
                    </g>
                </g>
            </svg>
        )
    }
}
